import { render, staticRenderFns } from "./closeWorkorder.vue?vue&type=template&id=9be57f70"
import script from "./closeWorkorder.vue?vue&type=script&lang=js"
export * from "./closeWorkorder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9be57f70')) {
      api.createRecord('9be57f70', component.options)
    } else {
      api.reload('9be57f70', component.options)
    }
    module.hot.accept("./closeWorkorder.vue?vue&type=template&id=9be57f70", function () {
      api.rerender('9be57f70', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/center-business/workorder/closeWorkorder.vue"
export default component.exports